import React from 'react';
import { styles } from './PdfEnhancementPanel.styles';
import { Box, Typography } from '@mui/material';
import { ITab } from './TabBar/TabBar';
import { ACCESSIBILITY_CHECKER, FORMATTING, PDF_STYLING } from '../constants';
import { PdfStylingTab } from '../PdfStylingTab/PdfStylingTab';
import { IAccordionListNode } from '@opengov/component-library/capital/AccordionList/AccordionList';
import { ISetupPdfMessages } from '../../../../../types/setupPDFTypes';
import { ISessionUser } from '../../../../../types/storiesTypes';
import { IPublicationSetupPdfStyle } from '@opengov/stories-shared/constants';
import { LoadingSpinner } from '../../../SetupPDFComponents/LoadingSpinner/LoadingSpinner';

export type IPdfEnhancementPanelProps = {
  activeTab: ITab;
  navigateToTab(tab: ITab): void;
  storiesSelectData: IAccordionListNode[] | null;
  messages: ISetupPdfMessages;
  publicationId?: string;
  sectionId?: string;
  user: ISessionUser;
  pdfStyles: IPublicationSetupPdfStyle | null;
  isLoadingStyles: boolean;
  skipAutoSave?: boolean;
};

export const PdfEnhancementPanel = ({
  activeTab,
  storiesSelectData,
  messages,
  publicationId,
  sectionId,
  user,
  pdfStyles,
  isLoadingStyles,
  skipAutoSave = false
}: IPdfEnhancementPanelProps) => {
  const getTabContent = (): React.ReactNode => {
    switch (activeTab.name) {
      case PDF_STYLING: {
        if (isLoadingStyles) {
          return <LoadingSpinner messages={messages} />;
        }
        return (
          <PdfStylingTab
            storiesSelectData={storiesSelectData}
            messages={messages}
            publicationId={publicationId}
            sectionId={sectionId}
            user={user}
            pdfStyles={pdfStyles}
            isLoadingStyles={isLoadingStyles}
            skipAutoSave={skipAutoSave}
          />
        );
      }
      case FORMATTING:
        return <Typography>Formatting</Typography>; // TODO: Add formatting tab content
      case ACCESSIBILITY_CHECKER:
        return <Typography>Accessibility Checker</Typography>; // TODO: Add accessibility checker tab content
      default:
        return null;
    }
  };
  return (
    <Box sx={styles.container}>
      {/* <TabBar activeTab={activeTab} tabs={TABS_PDF_ENHANCEMENT} navigateToTab={navigateToTab} /> */}
      <Box sx={styles.content}>{getTabContent()}</Box>
    </Box>
  );
};
